import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { AddContentToPlaylistDocument } from './add-content.generated';

export const useAddContentToPlaylist = (
  options: ApiOptions<typeof AddContentToPlaylistDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(AddContentToPlaylistDocument, {
    ...useNotifications(AddContentToPlaylistDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        t('api.playlists.add_items_success_plural', {
          count: data.addContentToPlaylist?.addedIds.length ?? 0,
        }),
    }),

    ...options,
  });
};
